export default __webpack_public_path__ + "static/media/icon-upload.c784bd57.svg";